/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class FileModelDirective {
    public scope = false;
    public restrict = 'A';


    constructor(private $parse: any) {

    }
    public link = (scope: any, element: any, attrs: any) => {
        let model = this.$parse(attrs.fileModel);
        let modelSetter = model.assign;

        element.bind('change', function(){
            scope.$apply(function(){
                modelSetter(scope, element[0].files[0]);
            });
        });
    };

    public static DirectiveFn($parse: any): FileModelDirective {
        return new FileModelDirective($parse);
    }
}

FileModelDirective.DirectiveFn.$inject = ['$parse'];

angular.module('beneple.global').directive('fileModel', FileModelDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/file-model.directive.ts